module.exports = __webpack_public_path__ + "img/effects-9.b0913b39.png";